export const SYSADMIN_CODE = "sysadmin";
export const ADMIN_CODE = "admin";
export const EMPLOYEE_CODE = "employee";
export const CUSTOMERS_CODE = "customers";
export const BUSINESS_CODE = "business";
export const LOGISTICS_CODE = "logistics";
export const MANAGER_CODE = "manager";
